import React from "react"

import './index.css'

const Titlebar001 = props => {
  const {title} = props
  return(
    <div className="titleBar001">
      <p>{title}</p>
    </div>
  )
}

export default Titlebar001
